<template>
  <div>
    <PageTagline :elements="tagline_elem" />
    <!-- Pagina di login per il servizio -->
    <AmilonLoginPage :service_title="service_title" :service="service"/>
  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import AmilonLoginPage from '@/components/amilon/AmilonLoginPage'

export default {
  name: 'AmlExpedia',
  data () {
    return {
        // Variabili generali
        tagline_elem : [ { text : "Expedia.com", link : 'conv-aml-expedia' } ],

        // variabili che definiscono il servizio expedia con la quale
        // configuriamo la pagina di login.
        service_title: "Expedia.com",
        service: 200
    }
  },
  components: {
    PageTagline,
    AmilonLoginPage
  }
}
</script>

<style scoped></style>